<script lang="ts">
  import type { Graphic } from "../types";
  import { sourcesAt } from "../support/graphics";

  export let src: Graphic;
  export let alt = "";

  export let height = 400;
</script>

{#if src}
  {#key src}
    <div class="HeroFrame">
      <picture class="HeroImage">
        <source srcset={sourcesAt(src, 1200)} media="(min-width: 1200px)" />
        <source srcset={sourcesAt(src, 800)} media="(min-width: 401px)" />
        <source srcset={sourcesAt(src, 400)} media="(max-width: 400px)" />

        <img {src} {alt} {height} fetchpriority="high" />
      </picture>
    </div>
  {/key}
{/if}

<style>
  .HeroFrame {
    background: #111;
    margin: 0;
    padding: 0;
    position: relative;
  }

  .HeroFrame:after {
    box-shadow: inset 0 -1px 0px 0px rgba(0, 0, 0, 0.24);
    bottom: 0;
    content: "";
    height: 10px;
    left: 0;
    opacity: 0.3;
    position: absolute;
    width: 100%;
  }

  .HeroImage source,
  .HeroImage img {
    display: block;
    max-height: 30vh;
    object-fit: cover;
    width: 100%;
  }
</style>
